module.exports = __webpack_public_path__ + "img/yellow.f303636d.jpg";